import { useState } from 'react';

import Button from '../../Ui/Button/Button';
import Modal from '../../Ui/Modal/Modal';

const ItemInfo = ({ image, title, description, isHasButton, modalText }) => {
	const [modalActive, setModalActive] = useState(false);

	const images = image;
	const titles = title;
	const descriptions = description;
	const isHasButtons = isHasButton;

	const buttonClickHandler = () => {
		setModalActive(true);
		document.body.style.paddingRight = '17px';
	}

	return (
		<div className="professions-main__item-box">
			<Modal active={modalActive} setActive={setModalActive} text={modalText} />
			<div className="professions-main__item">
				<div className="professions-main__image">
					<img src={images} alt="" />
				</div>
				<h3 className='professions-main__sub-title'>{titles}</h3>
				<div className="professions-main__text">{descriptions}</div>
				{isHasButtons &&
					<div className="professions-main__button-box" onClick={buttonClickHandler}>
						<Button variant={'white'} />
					</div>
				}
			</div>
		</div>
	)

}

export default ItemInfo;